import React from "react";
import Layout from "../Layout";
import Form from "./form";
import useApi from "Hooks/Admin/useApi";
import useError from "Hooks/useError";
import { message } from "constants/message";
import { withRouter } from "react-router";
import "dayjs/locale/ja";
import dayjs from "dayjs";
dayjs.locale("ja");

function Dtm(props) {
  const { request } = useApi();
  const stateError = useError();
  const messages = message();

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - DTM告知登録";
  }, []);

  const handleSubmit = (dtm) => {
    request({
      method: "POST",
      url: `admin/dtm_notices`,
      data: {
        valid_from: dtm.validFrom,
        valid_until: dtm.validUntil,
        label: dtm.label,
        desc: dtm.desc,
        message: dtm.dtmMessage,
      },
    })
      .then((data) => {
        stateError.initialize();
        props.history.push("/admin/dtm?success=create");
      })
      .catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };

  return (
    <Layout
      content={
        <Form
          submit={handleSubmit}
        />
      }
    />
  );
}
export default withRouter(Dtm);
